import {getAuthor} from "../author/getAuthor";
import {appendAnswerForSurvey} from "./appendAnswerForSurvey";
import {displaySurveyResult} from "./displaySurveyResult";
import {checkResultLine} from "../utils/checkResultLine";
import {dateToString} from "../utils/dateToString";
import {stringToDate} from "../utils/stringToDate";
import {addImpression} from "../utils/addImpression";
export function positionSurveyContents(jsonObj, lazyLoadOnThisPage) {
    var data = $.parseJSON(jsonObj);
    if (communityType === 1) { // Stammtisch
        $.each(data.timeline_elements, function (key, value) {
            var surveyAnswers = data.survey_answers[value.post_id];
            var container = $("#" + key + ".timeline_entry");
            if (surveyAnswers[0].active == 1) {
                container.find(".spinner").hide();
                var clonedBox = $(".survey_box_prototype").clone().appendTo(container);
                clonedBox.removeClass("survey_box_prototype");
                clonedBox.addClass("survey_box");
                clonedBox.removeClass("hidden");
                var survey = surveyAnswers[0];
                container.attr("data-type", survey.type);
                clonedBox.find(".prost_count").text(survey.sum_prosts);
                clonedBox.find(".question").text(survey.question);
                clonedBox.find(".answer-explanation").html(survey.rules);
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                var validTo = new Date();
                if (survey.validity_to === null) {
                    validTo = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                } else {
                    validTo = stringToDate(survey.validity_to);
                }
                if (survey.author !== "") {
                    getAuthor(survey, value);
                    if (data.timeline_elements[key] !== undefined) {
                        var printDate = data.timeline_elements[key].post_date;
                        printDate = dateToString(stringToDate(printDate), true).split(" ");
                        printDate = printDate[0] + " um " + printDate[1] + " Uhr";
                        clonedBox.find(".js-post-date").text(printDate);
                    }
                }

                now = new Date();
                if (validTo >= now) {
                    var answersContainer = clonedBox.find(".answers");
                    $.each(surveyAnswers, function (key, answer) {
                        if (key !== "posted_answers") {
                            appendAnswerForSurvey(survey, answer, answersContainer);
                        }
                    });
                    var pointsContainer = clonedBox.find(".item_points_banner.points_discount_banner");
                    if (survey.community_points > 0) {
                        pointsContainer.text(survey.community_points);
                        var tooltipContainer = clonedBox.find(".item_points_banner.points_discount_banner");
                        var tooltipText = typeof tooltipContainer.attr("data-original-title") != "undefined" ? tooltipContainer.attr("data-original-title").split("X") : "";
                        tooltipText = tooltipText[0] + survey.community_points + tooltipText[1];
                        tooltipContainer.attr("data-original-title", tooltipText);
                    } else {
                        pointsContainer.hide();
                    }
                } else {
                    var pointsContainerPast = clonedBox.find(".item_points_banner.points_discount_banner");
                    if (survey.community_points > 0) {
                        pointsContainerPast.text(survey.community_points);
                        var tooltipContainerPast = clonedBox.find(".item_points_banner.points_discount_banner");
                        var tooltipTextPast = tooltipContainerPast.attr("data-original-title").split("X");
                        tooltipTextPast = tooltipTextPast[0] + survey.community_points + tooltipTextPast[1];
                        tooltipContainerPast.attr("data-original-title", tooltipTextPast);
                    } else {
                        pointsContainerPast.hide();
                    }
                    displaySurveyResult(clonedBox, surveyAnswers, surveyAnswers["posted_answers"]);
                }
                clonedBox.find(".spinner").hide();
                addImpression(data.timeline_elements[key].id);
                checkResultLine();
            } else {
                container.remove();
            }
        });
        lazyLoad = lazyLoadOnThisPage;
    } else { // survey overview
        $.each(data.survey_answers, function (key, value) {
            var container = $("#" + key + ".timeline_entry");
            if (value[0].active == 1) {
                container.find(".spinner").hide();
                var clonedBox = $(".survey_box_prototype").clone().appendTo(container);
                clonedBox.removeClass("survey_box_prototype");
                clonedBox.addClass("survey_box");
                clonedBox.removeClass("hidden");
                var survey = value[0];
                clonedBox.find(".prost_count").text(survey.sum_prosts);
                clonedBox.find(".question").text(survey.question);
                clonedBox.find(".answer-explanation").html(survey.rules);
                container.attr("data-type", survey.type);
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                var validTo = new Date();
                if (survey.validity_to === null) {
                    validTo = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                } else {
                    validTo = stringToDate(survey.validity_to);
                }
                if (survey.author !== "") {
                    getAuthor(survey, value);
                    if (data.timeline_elements[key] !== undefined) {
                        var printDate = data.timeline_elements[key].post_date;
                        printDate = dateToString(stringToDate(printDate), true).split(" ");
                        printDate = printDate[0] + " um " + printDate[1] + " Uhr";
                        clonedBox.find(".js-post-date").text(printDate);
                    }
                }
                now = new Date();
                if (validTo >= now) {
                    var answersContainer = clonedBox.find(".answers");
                    $.each(value, function (key, answer) {
                        if (key !== "posted_answers") {
                            appendAnswerForSurvey(survey, answer, answersContainer);
                        }
                    });
                    var pointsContainer = clonedBox.find(".item_points_banner.points_discount_banner");
                    if (survey.community_points > 0) {
                        pointsContainer.text(survey.community_points);
                        var tooltipContainer = clonedBox.find(".item_points_banner.points_discount_banner");
                        var tooltipText = typeof tooltipContainer.attr("data-original-title") != "undefined" ? tooltipContainer.attr("data-original-title").split("X") : "";
                        tooltipText = tooltipText[0] + survey.community_points + tooltipText[1];
                        tooltipContainer.attr("data-original-title", tooltipText);
                    } else {
                        pointsContainer.hide();
                    }
                } else {
                    var pointsContainerPast = clonedBox.find(".item_points_banner.points_discount_banner");
                    if (survey.community_points > 0) {
                        pointsContainerPast.text(survey.community_points);
                        var tooltipContainerPast = clonedBox.find(".item_points_banner.points_discount_banner");
                        var tooltipTextPast = tooltipContainerPast.attr("data-original-title").split("X");
                        tooltipTextPast = tooltipTextPast[0] + survey.community_points + tooltipTextPast[1];
                        tooltipContainerPast.attr("data-original-title", tooltipTextPast);
                    } else {
                        pointsContainerPast.hide();
                    }
                    displaySurveyResult(clonedBox, value, value["posted_answers"]);
                }
                clonedBox.find(".spinner").hide();
                checkResultLine();
            } else {
                container.remove();
            }
        });
        lazyLoad = lazyLoadOnThisPage;
    }
}